import { Component, OnInit } from '@angular/core';
// Services
import { ElasticService } from './../../services/elastic';
// External
import { Club } from './../../models/club';

import * as lodash from 'lodash';
import { ApiService } from './../../services/api';
import { DatePipe } from '@angular/common';


@Component({
    templateUrl: './advertisement.component.html'
})
export class AdvertisementComponent implements OnInit {
    public filterargs: Club;
    public imageLoader: boolean = true;
    public currentPage: number;
    public maxPage: number;
    public clubs: Array<any>;
    public query: string;
    public isClubShow = true

    public typingDelay: any;
    public pageSize: number;

    constructor(private elasticService: ElasticService, private apiService: ApiService, private datePipe: DatePipe) {
        this.currentPage = 0;
        this.pageSize = 100;
        this.query;
    }

    ngOnInit() {
        this.filterargs = new Club()
        this.goToPage(this.currentPage);
    }



    goToPage(index: number) {
        const fromIndex = index * this.pageSize;
        let queryParams = {}

        if (this.isClubShow) {
            queryParams = {
                'index': 'users',
                'type': 'club',
                'size': 600,
                'from': fromIndex,
                'body/query/match_phrase_prefix/isVerified': `true`
            };
        } else {
            queryParams = {
                'index': 'users',
                'type': 'company',
                'size': 600,
                'from': fromIndex,
                'body/query/match_phrase_prefix/isVerified': `true`
            };


        }

        console.log(queryParams)

        this.elasticService.search(queryParams)
            .then(result => {
                console.log(result);

                if (result) {
                    this.clubs = [];
                    lodash.forEach(result['hits'], async (item) => {
                        let club = item['_source'];
                        let isAdvertisement = await this.getAdvertisement(item['_id'])
                        console.log(club);
                        if (isAdvertisement && isAdvertisement.createdAt) {
                            club.isAdvertisement = true

                        } else {
                            club.isAdvertisement = false

                        }
                        this.clubs.push(lodash.assign({ $key: item['_id'] }, club));
                    });

                    window.scrollTo(0, 0);
                    this.currentPage = index;
                    this.maxPage = Math.ceil(result['total'] / this.pageSize);
                } else {
                    this.clubs = []
                }
                this.imageLoader = false;

            })
            .catch(error => {
                console.error(error);
            });
    }

    goNext() {
        const index = this.currentPage + 1;
        this.goToPage(index);
    }

    goPrev() {
        const index = this.currentPage - 1;
        this.goToPage(index);
    }

    getIndex(index: number) {
        return (this.currentPage * this.pageSize) + index + 1;
    }
    changeQuery() {
        clearTimeout(this.typingDelay);


        this.typingDelay = setTimeout(() => {
            this.goToPage(this.currentPage);
        }, 400);
    }
    async getAdvertisement(uid) {
        let promise = new Promise<any>((resolve, reject) => {
            if (typeof uid == "string") {
                this.apiService.object("advertisements/" + uid).then(result => {
                    result.key = uid;
                    resolve(result);
                });
            }
        });
        return promise;
    }
    addAdvertisement(club) {
        console.log(club)
        if (confirm('Are you sure? you want to add advertisement for this ' + (this.isClubShow ? 'Club' : 'Company'))) {
            this.apiService.set(`/advertisements/${club.$key}`, {
                createdAt: new Date().getTime() / 1000,
                type: club.type
            })
                .then(() => {
                    club.isAdvertisement = true
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }
    removeAdvertisement(club) {
        console.log(club)
        if (confirm('Are you sure? you want to remove advertisement for this ' + (this.isClubShow ? 'Club' : 'Company'))) {
            this.apiService.set(`/advertisements/${club.$key}`, null)
                .then(() => {
                    club.isAdvertisement = false

                })
                .catch(error => {
                    console.error(error);
                });
        }
    }

    showChange(isVerified: boolean) {
        this.isClubShow = isVerified;
        this.goToPage(0);
    }

}
